var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { MessageInputLarge } from './MessageInputLarge';
var UnMemoizedMessageInput = function (props) {
    var _a = props.additionalTextareaProps, additionalTextareaProps = _a === void 0 ? {} : _a, _b = props.disabled, disabled = _b === void 0 ? false : _b, _c = props.focus, focus = _c === void 0 ? false : _c, _d = props.grow, grow = _d === void 0 ? true : _d, _e = props.Input, Input = _e === void 0 ? MessageInputLarge : _e, _f = props.maxRows, maxRows = _f === void 0 ? 10 : _f, _g = props.publishTypingEvent, publishTypingEvent = _g === void 0 ? true : _g;
    return (React.createElement(Input, __assign({}, props, { additionalTextareaProps: additionalTextareaProps, disabled: disabled, focus: focus, grow: grow, maxRows: maxRows, publishTypingEvent: publishTypingEvent })));
};
/**
 * MessageInput - a high level component that has provides all functionality to the Input it renders.
 *
 * It exposes the [useMessageInput](https://getstream.github.io/stream-chat-react/#section-usemessageinput) hook, which accepts the MessageInput props and returns
 * all functions needed to customize and build your custom Input components.
 * @example ./MessageInput.md
 */
export var MessageInput = React.memo(UnMemoizedMessageInput);
